import * as React from 'react';
import { GridErrors } from './types';

interface GridErrorsProps {
  index: number;
  data: GridErrors;
}

export default function ShowGridErrors(props: GridErrorsProps): JSX.Element | null {
  if (props.data[props.index]) {
    return (
      <>
        {props.data[props.index].rows && (
          <div className="grid-error grid-error-block">{props.data[props.index].rows}</div>
        )}
        {props.data[props.index].columns && (
          <div className="grid-error grid-error-block">{props.data[props.index].columns}</div>
        )}
      </>
    );
  }
  return null;
}
